import { WorkflowApproverResponse } from '~/api/approvers'
import fetch from '~/common/fetch'
import { formatDataDate, formatFiltersApiTime } from '~/common/dateUtils'
import { VndlyAlert } from '~/common/VndlyAlert'
import { ApprovalResults } from '~/components/approvals/modal/SelectApproversModal'

type ActionKey = string
type FormData = Record<string, any>
type IconDef = {
  id: string
  color: string
}

export type ActionConfig = {
  show_budget: boolean
  show_end_time: boolean
}
export type ActionsData = {
  action: ActionKey
  name: string
  description: string
  icon: IconDef
  custom_form: string | undefined | null
  config: ActionConfig
}

type ActionsListResponse = Array<ActionsData>

const getQuickActions = (workOrderId: number): Promise<ActionsListResponse> =>
  fetch.get(`/api/v2/work-order-actions/${workOrderId}`)
const getQuickActionsForm = (workOrderId: number, action: ActionKey): Promise<Record<string, any>> =>
  fetch.get(`/api/v2/work-order-actions/${action}/${workOrderId}/form/`)
const submitQuickAction = (workOrderId: number, action: ActionKey, formData: FormData) =>
  fetch.post(`/api/v2/work-order-actions/${action}/${workOrderId}/submit/`, formData)
const approversForQuickActions = (
  workOrderId: number,
  action: ActionKey,
  formData: FormData
): Promise<WorkflowApproverResponse> =>
  fetch.post(`/api/v2/work-order-actions/${action}/${workOrderId}/approvers/`, formData)
const laborForQuickAction = (workOrderId: number, action: ActionKey, formData: FormData): Promise<number> =>
  fetch.post(`/api/v2/work-order-actions/${action}/${workOrderId}/labor_amount/`, formData)

export const workOrderQuickActionsApi = {
  getQuickActions,
  getQuickActionsForm,
  submitQuickAction,
  approversForQuickActions,
  laborForQuickAction
}

export const systemFormatFormDates = (formData: Record<string, any>) => {
  const date_keys = ['end_date', 'start_date']
  const time_keys = ['end_time']
  const entries = Object.entries(formData).map(([k, v]) => {
    if (date_keys.includes(k)) {
      return [k, formatDataDate(v)]
    }
    if (time_keys.includes(k)) {
      return [k, formatFiltersApiTime(v)]
    }
    return [k, v]
  })
  return Object.fromEntries(entries)
}

export const submitAction = async (
  workOrderId: number,
  action: ActionKey,
  formData: Record<string, any>,
  approvalData: ApprovalResults
) => {
  try {
    const submitData = approvalData.approvalsRequested ? { ...formData, approvers: approvalData.approvers } : formData
    await workOrderQuickActionsApi.submitQuickAction(workOrderId, action, submitData)
  } catch (error: any) {
    const errorMessages = error.body.non_field_errors
    if (errorMessages && errorMessages.length > 0) {
      VndlyAlert.invalidError.fire({ text: errorMessages[0] })
    } else {
      VndlyAlert.unexpectedError.fire()
    }
    throw Error(error)
  }
}
